import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { DataObjectUrl } from './DataObjectUrl';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { DataObjectDirectorySortField, DataObjectFilterDto } from '../types';
import { Page, PageRequestParams } from '../../common/queryClient';
import { DataObjectDirectoryDto } from '../schema';

type DataObjectQueryParams = DataObjectFilterDto &
  PageRequestParams<DataObjectDirectorySortField>;

const getDataObjects = (params?: DataObjectQueryParams) =>
  apiClient
    .get<Page<DataObjectDirectoryDto>>(expand(DataObjectUrl.base, params))
    .then((response) => response.data);

export const useListDataObjectsQuery = createApiQueryHook(
  ['dataObjects'],
  getDataObjects
);
